// ASCII effect configuration constants
export const ASCII_ROWS = 50;
export const ASCII_COLS = 50;
export const ASCII_SIZE = 0.1;
export const ASCII_INSTANCES = ASCII_ROWS * ASCII_COLS;

// ASCII character dictionary for texture generation
export const ASCII_DICT =
  "`.-':_,^=;><+!rc*/z?sLTv)J7(|Fi{C}fI31tlu[neoZ5Yxjya]2ESwqkP6h9d4VpOGbUAKXHm8RD#$Bg0MNWQ%&@";

// Color palette for ASCII material gradient
export const ASCII_COLOR_PALETTE = [
  "#8C1EFF",
  "#F222FF",
  "#FF2975",
  "#FF901F",
  "#FFD319",
];

